import { atom as t } from "jotai";
import { atomWithDefault as l } from "jotai/utils";
const r = t(null), a = l(
  (o) => o(r)
);
t(
  null,
  (o, e, m) => {
    e(a, m);
  }
);
export {
  a as selectedRoomAtom,
  r as selectedRoomAtomDefault
};
